import { FormattedMessage } from 'react-intl';

import { Body as CreateProductsBody } from './create-products/body';
import { Footer as CreateProductsFooter } from './create-products/footer';
import { messages } from './messages';
import { Body as PrepareProductsBody } from './prepare-products/body';
import { Footer as PrepareProductsFooter } from './prepare-products/footer';
import { Body as ScheduleReviewBody } from './schedule-review/body';
import { Footer as ScheduleReviewFooter } from './schedule-review/footer';
import { Body as SendProductsBody } from './send-products/body';
import { Footer as SendProductsFooter } from './send-products/footer';
import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';

const importExampleFile = '/s3/marketplaces/shipstation/FulfillmentProductImportSample.csv';

export const STEPS = Object.freeze({
  uploadProducts: 'uploadProducts',
  prepareProducts: 'prepareProducts',
  sendProducts: 'sendProducts',
  scheduleReview: 'scheduleReview',
});

/** @typedef {import("../types").StepDefinition} StepDefinition */

/**
 * @type {StepDefinition[]}
 */
export const WIZARD_DEFINITION = [
  {
    id: STEPS.uploadProducts,
    stepperLabel: <FormattedMessage {...messages.uploadProductsLabel} />,
    title: messages.uploadProductsTitle,
    description: (
      <FormattedMessage
        {...messages.uploadProductsDescription}
        values={{
          file: (chunks) => (
            <a href={importExampleFile} rel='noreferrer' target='_blank'>
              {chunks}
            </a>
          ),
          helpLink: (chunks) => <HelpArticleLink articleId={linkIDs.ImportCsvProducts}>{chunks}</HelpArticleLink>,
        }}
      />
    ),
    Body: CreateProductsBody,
    Footer: CreateProductsFooter,
  },
  {
    id: STEPS.prepareProducts,
    stepperLabel: <FormattedMessage {...messages.prepareProducts} />,
    title: messages.prepareProductsTitle,
    description: messages.prepareProductsDescription,
    Body: PrepareProductsBody,
    Footer: PrepareProductsFooter,
  },
  {
    id: STEPS.sendProducts,
    stepperLabel: <FormattedMessage {...messages.sendProductsLabel} />,
    title: messages.sendProductsTitle,
    description: messages.sendProductsDescription,
    Body: SendProductsBody,
    Footer: SendProductsFooter,
  },
  {
    id: STEPS.scheduleReview,
    stepperLabel: <FormattedMessage {...messages.scheduleReviewLabel} />,
    title: messages.scheduleReviewTitle,
    description: messages.scheduleReviewDescription,
    Body: ScheduleReviewBody,
    Footer: ScheduleReviewFooter,
  },
];

export const STEP_LABELS = WIZARD_DEFINITION.map((step) => step.stepperLabel);
